import { render, staticRenderFns } from "./type1.vue?vue&type=template&id=f78a73e0&scoped=true"
import script from "./type1.vue?vue&type=script&lang=js"
export * from "./type1.vue?vue&type=script&lang=js"
import style0 from "./type1.vue?vue&type=style&index=0&id=f78a73e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78a73e0",
  null
  
)

export default component.exports